function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GridMouseHandler, GridRowTreeMouseHandler, isExpandableGridModel } from '@deephaven/grid';
import { assertNotNull } from '@deephaven/utils';
import deepEqual from 'fast-deep-equal';
class IrisGridRowTreeMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super(750); // Needs to be before GridRowTreeMouseHandler
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  destroyTooltip() {
    this.irisGrid.setState({
      expandCellTooltipProps: null
    });
  }
  setCursor(gridPoint, grid) {
    if (GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid)) {
      this.cursor = 'pointer';
      return {
        stopPropagation: false,
        preventDefault: false
      };
    }
    this.cursor = null;
    return false;
  }
  getButtonPosition(_ref) {
    var x = _ref.x,
      y = _ref.y,
      column = _ref.column,
      row = _ref.row;
    if (column == null || row == null) {
      return null;
    }
    var _this$irisGrid = this.irisGrid,
      renderer = _this$irisGrid.renderer,
      grid = _this$irisGrid.grid,
      state = _this$irisGrid.state,
      props = _this$irisGrid.props;
    if (!grid) {
      return null;
    }
    var metrics = state.metrics;
    var model = props.model;
    var context = grid.canvasContext;
    var theme = grid.getTheme();
    var rendererState = {
      context,
      mouseX: x,
      mouseY: y,
      metrics,
      model,
      theme
    };
    var depth = isExpandableGridModel(model) ? model.depthForRow(row) : null;
    var _renderer$getExpandBu = renderer.getExpandButtonPosition(rendererState, depth),
      left = _renderer$getExpandBu.left,
      top = _renderer$getExpandBu.top,
      width = _renderer$getExpandBu.width,
      height = _renderer$getExpandBu.height;
    if (left == null || width == null || top == null || height == null) {
      return null;
    }
    return {
      left,
      top,
      width,
      height
    };
  }
  onMove(gridPoint, grid) {
    if (GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid)) {
      var expandCellTooltipProps = this.irisGrid.state.expandCellTooltipProps;
      var model = this.irisGrid.props.model;
      var newProps = this.getButtonPosition(gridPoint);
      var row = gridPoint.row;
      assertNotNull(row);
      var isRowExpanded = isExpandableGridModel(model) && model.isRowExpanded(row);
      if (!deepEqual(expandCellTooltipProps, newProps)) {
        this.irisGrid.setState({
          expandCellTooltipProps: newProps,
          expandTooltipDisplayValue: isRowExpanded ? 'collapse' : 'expand'
        });
      }
    } else {
      this.destroyTooltip();
    }
    return this.setCursor(gridPoint, grid);
  }
  onDown() {
    this.destroyTooltip();
    return false;
  }
  onContextMenu() {
    this.destroyTooltip();
    return false;
  }
  onWheel() {
    this.destroyTooltip();
    return false;
  }
  onLeave() {
    this.destroyTooltip();
    return false;
  }
}
export default IrisGridRowTreeMouseHandler;
//# sourceMappingURL=IrisGridRowTreeMouseHandler.js.map